import React from "react";
import Layout from "../Layout";
import HeaderSysAdmin from "./HeaderSysAdmin";
import FormSysAdminRegistration from "./FormSysAdminRegistration";

const RegistrationSysAdmin = () => (
    <Layout>
        <HeaderSysAdmin />
        <main className="layout-container">
            <div className="container">
                <div className="descript-container container-2">
                    <div className="form-title g-clr">System Administrator Registration</div>
                    Use this form to pre-register SYS Admin accounts. 
                    Email notification will be sent with a temporary password to login and change to a new password once they have logged in.
                </div>
                <FormSysAdminRegistration />
            </div>
        </main>
    </Layout>
);

export default RegistrationSysAdmin;